import React, { useEffect, useRef, useState } from "react";

const LeadInfo = (props) => {
  const infoForm = useRef(null);
  const [leadsMetrics, setLeadsMetrics] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const leadInfoCardData = [
    {
      title: "Total Leads",
      count: leadsMetrics?.totalLeads?.count || 0,
      amount: leadsMetrics?.totalLeads?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Online Leads",
      count: leadsMetrics?.onlineLeads?.count || 0,
      amount: leadsMetrics?.onlineLeads?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Offline Applications",
      count: leadsMetrics?.offlineLeads?.count || 0,
      amount: leadsMetrics?.offlineLeads?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Disbursed Leads",
      count: leadsMetrics?.totalDisbursedLeads?.count || 0,
      amount: leadsMetrics?.totalDisbursedLeads?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
  ];
  // REVENUE INFO

  const getPortfolioMetricsLeads = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    props.apis.apiGetPortfolioMetricsLeads(data, payload).then((res) => {
      setLeadsMetrics(res);
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "leadinfo-column-start_date",
      "leadinfo-column-end_date",
      "leadinfo-column-search_btn",
      "leadinfo-column-reset_btn",
    ];
    console.log({ val });
    if (val === "CUSTOM") {
      showInputs(inputs);
      setLeadsMetrics({});
    } else {
      hideInputs(inputs);
      setTimeline(val);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      start_date: new Date(data?.start_date).toISOString(),
      end_date: new Date(data?.end_date).toISOString(),
    };
    getPortfolioMetricsLeads(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "leadinfo-column-start_date",
      "leadinfo-column-end_date",
      "leadinfo-column-search_btn",
      "leadinfo-column-reset_btn",
    ];
    hideInputs(inputs);
    getPortfolioMetricsLeads({}, "TODAY");
  };

  useEffect(() => {
    getPortfolioMetricsLeads();
  }, [timeline]);

  props.$setNode({
    props,
    leadsMetrics,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <h2 className="fs-4 mt-2 float-left">Lead Info</h2>
        <div className="form_outer">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="leadinfo-column-start_date"
            >
              <AppInputFocus
                type="date"
                name="start_date"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="leadinfo-column-end_date"
            >
              <AppInputFocus
                type="date"
                name="end_date"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="leadinfo-column-search_btn"
            >
              <button type="submit" className="btn btn-primary search_btn">
                <i className="fa fa-search"></i>
                <span>Search</span>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="leadinfo-column-reset_btn"
            >
              <button
                type="button"
                className="btn btn-primary search_btn"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <span>Reset</span>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row pt-0">
          {leadInfoCardData &&
            leadInfoCardData.map((lead) => {
              return (
                <>
                  <div
                    className="col-xl-3 col-sm-6"
                    // onClick={(...args) => navigate(lead?.path)}
                  >
                    <div className="card dashboard_card application_card revenue_info_card">
                      <div className="card-body">
                        <div className="content">
                          <p className="card_label">{lead?.title}</p>
                          <p className="count">{lead?.amount?.curLakhs()}</p>
                          <p>Count : {lead?.count}</p>
                        </div>
                        <div className="icon_container">
                          {/* <div className="icon">
                            <img src={lead?.icon} alt="icon image" />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(LeadInfo);
